import type { FilterFieldConfig, FilterOption } from 'components/common/MasterFilter';
import {
  TICKET_MOTIVE_LABELS,
  TICKET_MOTIVES,
  TICKET_URGENCIES,
  TICKET_URGENCY_LABELS,
  type TicketStatusFilter,
} from 'services/types/ticket';

const TICKET_STATUS_OPTIONS: FilterOption[] = [
  { value: 'PENDING_NEW_MESSAGE', label: 'Pendiente - Nuevo mensaje' },
  { value: 'PENDING_AWAITING_RESPONSE', label: 'Pendiente - Esperando respuesta' },
  { value: 'ANALYSIS_WITH_AI', label: 'Análisis con IA' },
  { value: 'MANUAL_ANALYSIS_PENDING', label: 'Análisis manual pendiente' },
  { value: 'IN_PROGRESS', label: 'En progreso' },
  { value: 'BLOCKED', label: 'Bloqueado' },
  { value: 'CLOSED', label: 'Cerrado' },
  { value: 'DISMISSED', label: 'Descartado' },
];

const CATEGORY_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'Todos los tickets' },
  { value: 'withBusinessUnit', label: 'Unidades de negocio' },
  { value: 'rollbar', label: 'Rollbar Errors' },
  { value: 'other', label: 'Otros' },
];

const URGENCY_OPTIONS: FilterOption[] = TICKET_URGENCIES.map((r) => ({
  value: r,
  label: TICKET_URGENCY_LABELS[r],
}));

const MOTIVE_OPTIONS: FilterOption[] = TICKET_MOTIVES.map((m) => ({
  value: m,
  label: TICKET_MOTIVE_LABELS[m],
}));

const defaultVisibleStatuses = (isAdmin: boolean): TicketStatusFilter[] =>
  (isAdmin
    ? ([
        'PENDING_NEW_MESSAGE',
        'PENDING_AWAITING_RESPONSE',
        'ANALYSIS_WITH_AI',
        'MANUAL_ANALYSIS_PENDING',
        'IN_PROGRESS',
        'BLOCKED',
      ] as const)
    : ([
        'PENDING_NEW_MESSAGE',
        'PENDING_AWAITING_RESPONSE',
        'ANALYSIS_WITH_AI',
        'MANUAL_ANALYSIS_PENDING',
        'IN_PROGRESS',
        'BLOCKED',
        'DISMISSED',
      ] as const)
  ).slice();

export const buildTicketsFilterConfig = (isAdmin: boolean): FilterFieldConfig[] => [
  ...(isAdmin
    ? [
        {
          key: 'category',
          kind: 'singleSelect' as const,
          label: 'Tipo',
          placement: 'bar' as const,
          options: CATEGORY_OPTIONS,
          defaultValue: 'all',
        },
      ]
    : []),
  {
    key: 'statuses',
    kind: 'multiSelect',
    label: 'Estado',
    placement: 'bar',
    options: TICKET_STATUS_OPTIONS,
    defaultValue: defaultVisibleStatuses(isAdmin),
  },
  {
    key: 'businessUnitIds',
    kind: 'multiSelect',
    label: 'Unidad de negocio',
    placement: 'bar',
  },
  {
    key: 'createdByUserIds',
    kind: 'multiSelect',
    label: 'Creado por',
    placement: 'modal',
  },
  {
    key: 'interestedUserIds',
    kind: 'multiSelect',
    label: 'Asignado a',
    placement: 'bar',
  },
  {
    key: 'urgencies',
    kind: 'multiSelect',
    label: 'Urgencia',
    placement: 'bar',
    options: URGENCY_OPTIONS,
  },
  {
    key: 'motives',
    kind: 'multiSelect',
    label: 'Motivo',
    placement: 'modal',
    options: MOTIVE_OPTIONS,
  },
  {
    key: 'deadlineRange',
    kind: 'dateRange',
    label: 'Fecha límite de solución sugerida',
    placement: 'modal',
  },
  {
    key: 'createdRange',
    kind: 'dateRange',
    label: 'Fecha de creación',
    placement: 'modal',
  },
];
